import * as React from 'react';
import * as _ from 'lodash';
import styled from 'styled-components';
import Input, {StyledInput} from 'components/Input';
import {
  Container as SocialButton,
  SocialType,
} from 'components/SocialButton';

export interface SocialInputProps {
  type: SocialType,
  title?: string,
  value?: string,
  onBlur?: () => void,
}

const Wrapper = styled.div`
  display: grid;
  gap: 10px;
`;

const Title = styled.div`
  font-size: 13px;
  font-weight: 400;
  line-height: 17px;
  letter-spacing: 0.01em;
`;

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
  align-items: center;
  border-radius: 5px;
  background: ${({theme}) => `
    ${theme.variables.backgroundColor}
  `};

  ${SocialButton} {
    width: 20px;
    height: 20px;
  }

  ${StyledInput} {
    padding: 12px 14px 12px 48px;
  }
`;

const SocialButtonBox = styled.div`
  position: absolute;
  padding-left: 14px;
  pointer-events: none;
`;

/**
 * The component render social input
 * @param {ProfileUser} props
 * @return {React.ReactElement}
 * @constructor
 */
export default function SocialInput(
    props: SocialInputProps | any,
): React.ReactElement {
  const {type, title} = props;

  const inputProps = _.omit(props, ['title', 'type']);

  /**
   * The function return title component
   * @return {JSX.Element | undefined}
   */
  function getTitle() {
    if (title && title.trim()) {
      return (
        <Title>{title}</Title>
      );
    }
  }

  return (
    <Wrapper>
      {getTitle()}
      <Container>
        <SocialButtonBox>
          <SocialButton
            type={type}
            noEffect
          />
        </SocialButtonBox>
        <Input
          type="text"
          {...inputProps}
        />
      </Container>
    </Wrapper>
  );
};
